import React from 'react';
import { Box, Button } from '@material-ui/core';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { getAllBccUserAsync } from './bccUserStore/bccUserStoreSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { userColumn } from './columns';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';

function bccUser() {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [userName, setUserName] = React.useState('');
  const [access, setAccess] = React.useState('');
  const [status, setStatus] = React.useState('');

  const { allUser } = useSelector((state) => {
    const { bccUserReducer } = state;

    return {
      allUser: bccUserReducer.bccAllUser && bccUserReducer.bccAllUser.data,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(
        getAllBccUserAsync({
          params: { page: 1, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All users were fetched successfully!');
        });
    } catch (error) {
      toast.error('Users could not be fetched. Please try again!');
    }
  };
  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllBccUserAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Users were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };
  const handleSearchUser = () => {
    var emailValidate = /\S+@\S+\.\S+/;
    // API call
    dispatch(
      getAllBccUserAsync(
        emailValidate.test(userName)
          ? {
              params: {
                email: userName,
              },
            }
          : {
              params: {
                name: userName,
              },
            }
      )
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  const handleAccess = (e) => {
    setAccess(e.target.value);
    // API call
    dispatch(
      getAllBccUserAsync({
        params: { role: e.target.value },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  const handleStatus = (e) => {
    setStatus(e.target.value);
    // API call
    dispatch(
      getAllBccUserAsync({
        params: { status: e.target.value },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  return (
    <div>
      <Box display="flex" flex={10}>
        <Box sx={{ width: 350 }} mr={2} mb={2}>
          <BuzzInput
            size="small"
            placeholder="Search by Username or Email"
            search
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            onSubmitEditing={handleSearchUser}
          />
        </Box>
        <Box mr={2} sx={{ width: 165 }}>
          <Link to="/user-management/add-user">
            <Button color="primary" size="large" variant="outlined">
              Add an Employee
            </Button>
          </Link>
        </Box>
        <Box mr={2} sx={{ width: 140 }}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            options={[
              { label: 'bccSchoolAdmin', value: 'bccSchoolAdmin' },
              { label: 'bccDiscoveryAdmin', value: 'bccDiscoveryAdmin' },
              { label: 'bccAtheneumAdmin', value: 'bccAtheneumAdmin' },
              { label: 'bccAkademyAdmin', value: 'bccAkademyAdmin' },
            ]}
            placeholder="Role"
            value={access}
            onChange={handleAccess}
            size="small"
          />
        </Box>
        <Box mr={2} sx={{ width: 140 }}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            options={[
              { label: 'Active', value: 'active' },
              { label: 'In-Active', value: 'inactive' },
            ]}
            placeholder="Status"
            value={status}
            onChange={handleStatus}
            size="small"
          />
        </Box>
      </Box>
      <BuzzTable columns={userColumn} data={allUser && allUser.users} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={allUser && allUser.count}
          pageNo={page}
          defaultPage={1}
          perPage={10}
        />
      </Box>
    </div>
  );
}

export default bccUser;
